"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.propsChanged = propsChanged;
function propsChanged(prev, next) {
	for (var key in prev) {
		if (prev[key] !== next[key]) return true;
	}return false;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-sigma/lib/Utils.js
 ** module id = 471
 ** module chunks = 0
 **/